const Footer = () => {
  return (
    <footer className="border-t bg-background py-8 sm:py-12">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col gap-4 sm:gap-6 md:flex-row md:justify-between md:items-center">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            &copy; 2025 The Lost Strings. Creating unforgettable moments through live music.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm text-muted-foreground">
            <span>🇺🇸 Serving North America</span>
            <span className="hidden sm:inline">•</span>
            <span>130+ Musicians</span>
            <span className="hidden sm:inline">•</span>
            <span>24hr Response</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
